'use strict';

import template from './photoLightbox.template.html';
import controller from './photoLightbox.controller.js';

import './photoLightbox.scss';

const component = {
    bindings: {},
    controller,
    template
};

export default component;
